(() => {
  const SELECTOR = '[data-wazup-hero-slider]';
  const INTERVAL = 6000;
  const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]';

  function initSlider(slider) {
    if (!slider || slider.dataset.wazupHeroReady === 'true') return;
    slider.dataset.wazupHeroReady = 'true';

    const slides = [...slider.querySelectorAll('[data-wazup-hero-slide]')];
    const tabs = [...slider.querySelectorAll('[data-wazup-hero-go]')];
    const previous = slider.querySelector('[data-wazup-hero-prev]');
    const next = slider.querySelector('[data-wazup-hero-next]');
    const toggle = slider.querySelector('[data-wazup-hero-toggle]');
    const status = slider.querySelector('[data-wazup-hero-status]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer;
    let paused = reduceMotion;
    let pointerStartX;

    if (slides.length < 2 || !toggle) return;

    function restartProgress() {
      const activeTab = tabs[current];
      activeTab.classList.remove('is-active');
      void activeTab.offsetWidth;
      activeTab.classList.add('is-active');
    }

    function schedule() {
      window.clearTimeout(timer);
      if (!paused && !document.hidden) timer = window.setTimeout(() => show(current + 1), INTERVAL);
    }

    function show(index, announce = true) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll(FOCUSABLE).forEach((element) => {
          if (active) element.removeAttribute('tabindex');
          else element.setAttribute('tabindex', '-1');
        });
      });
      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === current;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      if (announce && status) {
        const name = slides[current].dataset.slideName || `Slide ${current + 1}`;
        status.textContent = `Showing ${name}, slide ${current + 1} of ${slides.length}`;
      }
      restartProgress();
      schedule();
    }

    function setPaused(value) {
      paused = value;
      slider.classList.toggle('is-paused', paused);
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      schedule();
    }

    previous.addEventListener('click', () => show(current - 1));
    next.addEventListener('click', () => show(current + 1));
    toggle.addEventListener('click', () => setPaused(!paused));
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => show(index));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        show(current + direction);
        tabs[current].focus();
      });
    });

    slider.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') pointerStartX = event.clientX;
    });
    slider.addEventListener('pointerup', (event) => {
      if (pointerStartX == null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) >= 44) show(current + (distance < 0 ? 1 : -1));
    });
    slider.addEventListener('mouseenter', () => window.clearTimeout(timer));
    slider.addEventListener('mouseleave', schedule);
    slider.addEventListener('focusin', () => window.clearTimeout(timer));
    slider.addEventListener('focusout', schedule);
    document.addEventListener('visibilitychange', schedule);

    setPaused(paused);
    show(0, false);
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initSlider);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
